import { CompanyContact } from "../../entity/CompanyContact";
import { HttpAdapter } from "../../main/adapters/HttpAdapter";

export class CompanyContactHttpGateway {
    HttpAdapter = new HttpAdapter();
    baseUrl = `${publicSettings.aws.baseUrls.company}/company/contact`;
    async getByAccountingId(accountingId) {
        if (!accountingId) return [];

        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/get-by-accountingid`,
            { accountingId }
        );

        if (!response) return [];

        const contactList = [];

        for (const contact of response.list) {
            const entity = CompanyContact.restore(contact);

            contactList.push(entity);
        }

        return contactList;
    }

    async getByCompanyId(companyId) {
        if (!companyId) return [];

        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/get-by-companyid`,
            { companyId }
        );

        if (!response) return [];

        const contactList = [];

        for (const contact of response.list) {
            contactList.push(CompanyContact.restore(contact));
        }

        return contactList;
    }

    async create({ accountingId, companyId, name, email } = {}) {
        if (!accountingId || !companyId || !name || !email) return false;

        const response = await this.HttpAdapter.call(`${this.baseUrl}/create`, {
            accountingId,
            companyId,
            name,
            email
        });

        return response;
    }

    async updateById({ _id, accountingId, companyId, name, email } = {}) {
        if (!_id || !accountingId || !companyId || !name || !email)
            return false;

        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/update-by-id`,
            { id: _id, accountingId, companyId, name, email }
        );

        return response;
    }

    async removeById({ accountingId, _ids, type }) {
        if (!_ids?.length || !accountingId || !type) return;
        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/remove-by-id`,
            { accountingId, _ids, type }
        );
        return response;
    }

    async getById(contactId) {
        if (!contactId) return {};

        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/get-by-id`,
            { contactId }
        );

        return CompanyContact.restore(response);
    }

    async saveMany({ accountingId, contacts, type }) {
        if (!accountingId || !contacts?.length || !type) return;
        const input = {
            accountingId,
            type,
            contacts
        };
        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/save-many`,
            input
        );
        return response;
    }
}
